<!-- Toolbar -->
<!--<div class="toolbar" role="banner">-->
<!--    <img height="50px" src="../assets/logo-gris.png" (click)="navigateToHome()">-->
<!--    <div class="spacer"></div>-->
<!--    &lt;!&ndash;<button mat-button (click)="openDialog()">Open dialog</button>&ndash;&gt;-->

<!--</div>-->
<div class="loading-indicator" *ngIf="spinnerService?.visibility | async">
        <mat-progress-spinner [color]="'warn'" style="    margin-left: -36px;" mode="indeterminate"></mat-progress-spinner>
</div>
<div class="content" role="main">
</div>
<router-outlet></router-outlet>
